import axios from 'axios';
import {formatDbDate, moment} from '../../react/config.js';
import {formatDate} from '../../react/config.js';

let headers = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    'Content-Type': 'application/json'
};

$('.settings__section-2fa-toggle input').on('change', function () {
    let $input = this;
    let $form = $($input).closest('.settings__section-2fa').find('.settings__section-2fa-item');
    let disabledClass = 'settings__section-2fa-item--disabled';

    if ($input.checked) {
        $form.removeClass(disabledClass);
    } else {
        $form.addClass(disabledClass);
    }
});

function limitRangeInput(options) {
    let $slider = $(options.$slider);
    let balance = parseFloat(options.balance);
    let limit = options.limit > 0 ? parseFloat(options.limit) : balance;
    let reserve = 100;
    let toFixed = parseInt(options.toFixed);

    let percentage = 201;

    if (limit > balance) {
        percentage = parseInt(limit / (balance / 100)) + reserve;
    }

    let startValue = 100;

    if (limit !== balance) {
        startValue = parseInt(limit / (balance / 100));
    }

    let percentageElem = `
        <div class="range-slider__item-handle-percentage">
            <div class="range-slider__item-handle-percentage-item"></div>
        </div>
    `;

    let $percentageItem;
    let $input = $slider.closest('.settings__limit').find('input');
    let $handler;

    function refreshPercentageItem() {

        if (isNaN($slider.slider("option", "value"))) {
            $percentageItem.text('0%');
        } else {
            $percentageItem.text($slider.slider("option", "value") + '%');
        }
    }

    function refreshInputValue() {
        let val = balance / 100 * parseFloat($slider.slider("option", "value"));
        $input.val(val.toFixed(toFixed));
    }

    $input.on('input', function () {
        let currentPercentage = parseInt(parseFloat($input.val()) / (balance / 100));
        $slider.slider('value', currentPercentage);

        if (currentPercentage < 0) {
            $slider.slider('value', 0);
        } else if (currentPercentage > (percentage - 1)) {
            $slider.slider('value', percentage - 1);
            $percentageItem.text(currentPercentage + '%');
        }
    });

    $slider.slider({
        min: -1,
        max: percentage,
        range: 'min',
        slide: function (event, ui) {
            refreshPercentageItem();
            refreshInputValue();
        },
        change: function (event, ui) {
            refreshPercentageItem();
        },
        value: startValue,
        classes: {
            "ui-slider": "ui-corner-all range-slider__item-line",
            "ui-slider-handle": "ui-corner-all range-slider__item-handle",
            "ui-slider-range": "ui-corner-all ui-widget-header range-slider__item-line range-slider__item-line--progress"
        },
        create: function (event, ui) {
            $(percentageElem).appendTo($slider.find('.range-slider__item-handle'));
            $percentageItem = $slider.find('.range-slider__item-handle-percentage-item');
            $handler = $slider.find('.range-slider__item-handle');
            refreshPercentageItem();
        }
    });
}

window.limitSliderInit = function (balance) {
    let $sliderUSDT = document.getElementsByClassName('settings__limit-range-item')[0];
    let $sliderBTC = document.getElementsByClassName('settings__limit-range-item')[1];

    limitRangeInput({
        $slider: $sliderUSDT,
        balance: balance.usdt,
        limit: $sliderUSDT.dataset.limit,
        toFixed: $sliderUSDT.dataset.round,
    });

    limitRangeInput({
        $slider: $sliderBTC,
        balance: balance.btc,
        limit: $sliderBTC.dataset.limit,
        toFixed: $sliderBTC.dataset.round,
    });

};

if (document.getElementById('freePayment')) {
    getSubscribes();

    async function getSubscribes() {
        try {
            let response = await axios.get('/subscribe');
            window.subscribesInfo = response.data;

            if (isNaN(window.subscribeId)) {
                window.subscribeId = 1;
            }

            const $button = document.querySelector(`.cost__connect-send[data-subscribe="${window.subscribeId}"]`)

            $button.closest('.cost__box-connect').classList.add('cost__box-connect--active');
            $button.closest('.cost__box').classList.add('cost__box--active');

            paymentRangeInput($('.payment-input'), 1, 24, 1);
            initFreePayment();
            setSubscribeInfo(1);

            $('.payment-input__header-title--current-rate').text($('.cost__box--active .cost__box-title-inner').text());

            let dayInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

            let oneDayMonth = new Date(formatDbDate(window.paidTo)).getMonth();
            let oneDayPrice;

            window.subscribesInfo.find(subscribe => {
                if (subscribe.id === window.subscribeId) {
                    oneDayPrice = Math.ceil(parseInt(subscribe.price) / dayInMonth[oneDayMonth]);
                }
            });

            document.getElementById('one-work-day').innerText = oneDayPrice;
        } catch (event) {
            console.dir(event);
        }
    }
}

function initFreePayment() {

    toggleChangeSubscribe();

    payment();

    function toggleChangeSubscribe() {
        let $changeSubscribeForm = document.querySelector('.cost__grid');
        let $changeSubscribeButton = document.querySelector('.cost__footer-button');

        if (checkChangeSubscribe()) {
            $changeSubscribeForm.classList.remove('cost__grid--disabled');
            window.subscribeChangeAvailable = true;
            toggleChangeSubscribeButtons();
        }

        function checkChangeSubscribe() {
            if (window.subscribeChange === '') {
                return true;
            }

            let changeDate = moment(new Date(window.subscribeChange));
            let today = moment(new Date());
            let duration = moment.duration(today.diff(changeDate));

            return duration.asMonths() >= 1;
        }

        function toggleChangeSubscribeButtons() {

            let itemClass = 'cost__box';
            let itemActiveClass = 'cost__box--active';
            let subItemClass = 'cost__box-connect';
            let subItemActiveClass = 'cost__box-connect--active';

            let buttons = document.querySelectorAll('.cost__connect-send');
            let $paidToInput = document.querySelector('.cost__footer-buttons-date-block--paid-to .settings__limit-balance-value');
            let items = document.querySelectorAll(`.${itemClass}`);
            let subItems = document.querySelectorAll(`.${subItemClass}`);


            for (let $button of buttons) {
                $button.addEventListener('click', event => {

                    let $currentItem = event.target.closest('.' + itemClass);
                    let $currentSubItem = event.target.closest('.' + subItemClass);

                    if (!$currentSubItem.classList.contains(itemActiveClass)) {
                        for (let $item of items) {
                            $item.classList.remove(itemActiveClass);
                        }

                        for (let $subItem of subItems) {
                            $subItem.classList.remove(subItemActiveClass);
                        }

                        $currentItem.classList.add(itemActiveClass);
                        $currentSubItem.classList.add(subItemActiveClass);

                        if (parseInt($button.dataset.subscribe) === window.subscribeId) {
                            $paidToInput.innerHTML = window.paidTo;
                            $changeSubscribeButton.disabled = true;
                        } else {
                            $changeSubscribeButton.disabled = false;
                            window.subscribeNewId = parseInt($button.dataset.subscribe);
                            let paidToDate = getPaidToDate(window.subscribeNewId);
                            paidToDate.then(date => {
                                $paidToInput.innerHTML = formatDate(date);
                            });
                        }

                    }
                });
            }

            $changeSubscribeButton.addEventListener('click', () => {
                sendSubscribe(window.subscribeNewId);
            });
        }
    }

    function payment() {
        let $paymentButton = document.querySelector('.payment__button');
        let $paymentInput = document.getElementById('payment-input__form-input');

        $paymentButton.addEventListener('click', () => {
            if (!$paymentButton.classList.contains('disabled')) {
                redirectPayment($paymentInput.value);
            }
        });
    }
}

function setSubscribeInfo(month) {
    let cost;

    window.subscribesInfo.find(subscribe => {
        if (subscribe.id === window.subscribeId) {
            cost = subscribe.price;
        }
    });

    window.fullPayment = month * cost;
    $('#payment-input__form-input').val(window.fullPayment);
    $('.payment-input__header-number--duration .payment-input__header-number-item').text(month);
    $('.payment-input__header-number--payment .payment-input__header-number-item').text(window.fullPayment);
}

function paymentRangeInput($slider, minValue, maxValue, initValue, val_start_2) {
    let $sliderItem = $slider.find('.payment-input__item');

    $sliderItem.slider({
        min: minValue,
        max: maxValue,
        slide: function (event, ui) {
            setSubscribeInfo(ui.value);
        },
        create: function (event, ui) {
            document.querySelector('.payment__button').disabled = false;
        },
        change: function (event, ui) {
        },
        value: initValue,
        classes: {
            "ui-slider": "ui-corner-all range-slider__item-line",
            "ui-slider-handle": "ui-corner-all range-slider__item-handle",
            "ui-slider-range": "ui-corner-all ui-widget-header range-slider__item-progress"
        }
    });
}


async function redirectPayment(amount) {
    try {
        let response = await axios.post(window.paymentRoute, {
            headers: headers,
            amount: amount,
            locale: window.locale
        });

        window.location.href = response.data.url;
    } catch (event) {
        console.dir(event);
    }
}


async function getPaidToDate(subscribe) {
    try {
        let response = await axios.get(`/subscribe/date?subscribe=${subscribe}`);
        return response.data.date;
    } catch (event) {
        console.dir(event);
    }
}

async function sendSubscribe(subscribeId) {
    try {
        let response = await axios.post(`/subscribe/${subscribeId}`, {
            headers: headers
        });
        window.location.reload();
    } catch (event) {
        console.dir(event);
    }
}
